import { Suspense } from 'react'
import { toolRenderers } from './renderers'

interface ToolRendererProps {
  toolId: string
}

export default function ToolRenderer({ toolId }: ToolRendererProps) {
  const Renderer = toolRenderers[toolId]

  if (!Renderer) {
    return (
      <div
        style={{
          padding: 24,
          background: 'var(--g50)',
          borderRadius: 'var(--r)',
          border: '1px solid var(--g200)',
          textAlign: 'center',
          color: 'var(--g500)',
          fontSize: '.85rem',
        }}
        data-testid={`tool-renderer-placeholder-${toolId}`}
      >
        Tool renderer for <strong>{toolId}</strong> is not yet implemented.
      </div>
    )
  }

  return (
    <Suspense
      fallback={
        <div data-testid={`tool-renderer-loading-${toolId}`} style={{ padding: 24, color: 'var(--g500)' }}>
          Loading tool...
        </div>
      }
    >
      <Renderer toolId={toolId} />
    </Suspense>
  )
}
